export default function toggleOverflowBody() {
  const bodyElement = document.querySelector("body");
  bodyElement.classList.toggle("overflow-y-hidden");
}
